import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const ContactGeniousDataPage = () => {
  const { type, code } = useParams();  
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  useEffect(() => {
    if (type === 'pri') {
      const isAuthenticated = checkAuthentication(); 
      if (!isAuthenticated) {
        navigate('/login');
      } else {
        fetchData(code);
      }
    } else if (type === 'pub') {
      fetchData(code);
    }
  }, [type, code, navigate]);

  const fetchData = (code) => {
    fetch(`${process.env.REACT_APP_API_URL}/data/${code}`)
      .then(response => response.json())
      .then(data => setData(data))
      .catch(error => console.error('Error fetching data:', error));
  };
  
  const checkAuthentication = () => {
    return false; 
  };

  return (
    <div>
      {data ? (
        <div>
          <h1>{data.title}</h1>
          <p>{data.description}</p>
        </div>
      ) : (
        <p>Loading data...</p>
      )}
    </div>
  );
};

export default ContactGeniousDataPage;
